import React, { useEffect, useState } from "react";
import Details from "../components/Details";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
function ProjectDetails(){
const params=useParams();
const mode= useSelector(state=>state.Theme)
const[isDark,setMode]=useState();
useEffect(()=>{
    setMode(mode)
},[mode])
return(
    <div className={`${isDark&&"dark"} dark:bg-slate-900 w-screen `}>
        <Details id ={params.projectId}/>
    </div>
)
}
export default ProjectDetails;